/**
 * Refer to this repo: https://github.com/onury/accesscontrol
 */
import { AccessControl, Query } from "accesscontrol"
import { useMemo } from "react"

export enum USER_ROLES {
  ADMIN = "admin",
  USER = "user",
  RIV = "recruiter-insights-viewer",
  ASSESSOR = "assessor",
  FACILITATOR = "facilitator"
}

export const GRANTS_OBJECT = {
  admin: {
    customer: {
      "create:any": ["*"],
      "read:any": ["*"],
      "update:any": ["*"],
      "delete:any": ["*"]
    },
    // Predictor is a field in customer collection but we want to treat it separately
    predictor: {
      "create:any": ["*"],
      "read:any": ["*"],
      "update:any": ["*"],
      "delete:any": ["*"]
    },
    user: {
      "create:any": ["*"],
      "read:any": ["*"],
      "update:any": ["*"],
      "delete:any": ["*"]
    },
    vacancy: {
      "create:any": ["*"],
      "read:any": ["*"],
      "update:any": ["*"],
      "delete:any": ["*"]
    },
    prediction: {
      "create:any": ["*"],
      "read:any": ["*"],
      "update:any": ["*"],
      "delete:any": ["*"]
    },
    cxresponse: {
      "read:any": ["*"]
    },
    ti: {
      "read:any": ["*"]
    },
    li: {
      "create:any": ["*"],
      "read:any": ["*"],
      "update:any": ["*"],
      "delete:any": ["*"]
    }
  },
  // in PH user role (customer's user) can not access or modify their information, only admin role (PH's admin user) can do so
  user: {
    vacancy: {
      "create:own": ["*"],
      "read:own": ["*"],
      "update:own": ["*"],
      "delete:own": ["*"]
    },
    prediction: {
      "create:own": ["*"],
      "read:own": ["*"],
      "update:own": ["*"],
      "delete:own": ["*"]
    }
  },
  "recruiter-insights-viewer": {
    ti: {
      "read:own": ["*"]
    }
  },
  assessor: {
    li: {
      "create:own": ["*"],
      "read:own": ["*"],
      "update:own": ["*"],
      "delete:own": ["*"]
    }
  },
  facilitator: {
    li: {
      "create:any": ["*"],
      "read:any": ["*"],
      "update:any": ["*"],
      "delete:any": ["*"]
    }
  }
}

export type UserCan = Query & {
  [key: string]: any
}

export const useRBAC = (roles: string[], grantsObject = GRANTS_OBJECT) => {
  roles = roles || []
  const accessControl = useMemo(() => {
    const accessControl = new AccessControl(grantsObject)
    // lock accessControl in case of being modified in other place
    accessControl.lock()
    return accessControl
  }, [grantsObject])

  const userCan: UserCan = accessControl.can(roles)
  return {
    accessControl,
    userCan
  }
}
